export default "__VITE_ASSET__JTTaqsdf__"